import * as React from "react";
import {
  Admin,
  Resource,
  createMuiTheme,
  resolveBrowserLocale,
  usePermissions,
} from "react-admin";
// import jsonServerProvider from 'ra-data-json-server';
import { GalleryList, GalleryCreate, GalleryEdit } from "./Gallery";
import {
  SubscriptionList,
  SubscriptionCreate,
  SubscriptionEdit,
} from "./Subscription";
import { TransactionList } from "./Transaction";
import { VideoList, VideoCreate, VideoEdit } from "./Video";
import { TagCreate, TagEdit, TagList } from "./Tag";
import {
  WebzoneUniverseCreate,
  WebzoneUniverseEdit,
  WebzoneUniverseList,
} from "./WebzoneUniverse";
import { UniverseList, UniverseCreate, UniverseEdit } from "./Universe";
import Dashboard from "./Dashboard";
import authProvider from "./authProvider";
import dataProvider from "./dataProvider";
// import PostIcon from '@material-ui/icons/Book';
// import UserIcon from '@material-ui/icons/Group';
import OndemandVideoIcon from "@material-ui/icons/OndemandVideo";
import VodIcon from "@material-ui/icons/OndemandVideoTwoTone";
import PhotoAlbumIcon from "@material-ui/icons/PhotoAlbum";
import WebIcon from "@material-ui/icons/Web";
import LayersIcon from "@material-ui/icons/Layers";
import BookmarksIcon from "@material-ui/icons/Bookmarks";
import SurveyIcon from "@material-ui/icons/Poll";
import CastingApplicationIcon from "@material-ui/icons/HowToReg";
import Message from "@material-ui/icons/Message";
import People from "@material-ui/icons/People";
import Payment from "@material-ui/icons/Payment";
import Subscriptions from "@material-ui/icons/Subscriptions";
import Whatshot from "@material-ui/icons/Whatshot";

import authReducer from "./authReducer";
import { UserEdit, UserList } from "./User";
import { PageCreate, PageEdit, PageList } from "./Page";
import polyglotI18nProvider from "ra-i18n-polyglot";
import frenchMessages from "ra-language-french";
import englishMessages from "ra-language-english";
import { MessageEdit, MessageList } from "./Message";
import {
  GlobalMessageCreate,
  GlobalMessageEdit,
  GlobalMessageList,
} from "./GlobalMessage";
import { TeaserEdit, TeaserList } from "./Teaser";
import { NewsList, NewsCreate, NewsEdit } from "./News";
import { SurveyEdit, SurveyList } from "./Surveys";
import { VodCreate, VodEdit, VodList } from "./Vod";
import { VodTransactionList } from "./VodTransaction";
import { CastingApplicationList, CastingApplicationShow } from "./CastingApplication";
// import LoginPage from './LoginPage';
// import MyLoginPage from "./MyLoginPage";
// const dataProvider = jsonServerProvider('https://jsonplaceholder.typicode.com');

const theme = createMuiTheme({
  palette: {
    type: "dark", // Switching the dark mode on is a single property value change.
    primary: {
      main: "#f0e4b3",
    },
  },
});

const messages = {
  fr: frenchMessages,
  en: englishMessages,
};
const i18nProvider = polyglotI18nProvider(
  (locale) => (locale === "fr" ? messages.fr : messages.en),
  // locale => messages[locale] ? messages[locale] : messages.fr ,
  resolveBrowserLocale()
);
const ConditionalDashboard = () => {
    const { permissions, loading } = usePermissions();

    if (loading) return (<div>Loading...</div>);

    if (permissions !== 'admin') {
        return (
          <div>
            <h1>Bienvenue sur le tableau de bord de Little Angels</h1>
            <p>Vous n'avez pas les permissions nécessaires pour accéder au tableau de bord complet.</p>
            <p>Veuillez contacter l'administrateur pour plus d'informations.</p>
          </div>
        )
    }

    return <Dashboard/>;
};
// const i18nProvider = polyglotI18nProvider(() => frenchMessages, 'fr');
const App = () => {
  // resetCookies()
  return (
    // <Admin dashboard={Dashboard} dataProvider={dataProvider} authProvider={authProvider} customReducers={{ acces_token: authReducer }} loginPage={LoginPage}>
    <Admin
      i18nProvider={i18nProvider}
      theme={theme}
      dashboard={ConditionalDashboard }
      dataProvider={dataProvider}
      authProvider={authProvider}
      customReducers={{ acces_token: authReducer }}
    >
      {permissions => [
      permissions === 'admin' && 
      <Resource
        name="Teaser"
        options={{ label: "Teasers" }}
        list={TeaserList}
        // create={TeaserCreate}
        edit={TeaserEdit}
        icon={OndemandVideoIcon}
      />,
      permissions === 'admin' && 
      <Resource
        name="Gallery"
        list={GalleryList}
        edit={GalleryEdit}
        create={GalleryCreate}
        icon={PhotoAlbumIcon}
      />,
      permissions === 'admin' && 
      <Resource
        name="Video"
        list={VideoList}
        edit={VideoEdit}
        create={VideoCreate}
        icon={OndemandVideoIcon}
      />,
      permissions === 'admin' && 
      <Resource
        name="Vod"
        list={VodList}
        edit={VodEdit}
        create={VodCreate}
        icon={VodIcon}
      />,
      permissions === 'admin' && 
      <Resource
        name="Universe"
        list={UniverseList}
        edit={UniverseEdit}
        create={UniverseCreate}
        icon={Whatshot}
      />,
      permissions === 'admin' && 
      <Resource
        name="Tag"
        list={TagList}
        create={TagCreate}
        edit={TagEdit}
        icon={BookmarksIcon}
      />,
      permissions === 'admin' && 
      <Resource
        name="WebzoneUniverse"
        options={{ label: "Web zones Universes" }}
        list={WebzoneUniverseList}
        create={WebzoneUniverseCreate}
        edit={WebzoneUniverseEdit}
        icon={LayersIcon}
      />,
      permissions === 'admin' && 
      <Resource
        name="Page"
        list={PageList}
        create={PageCreate}
        edit={PageEdit}
        icon={WebIcon}
      />,
      permissions === 'admin' && 
      <Resource
        name="Subscription"
        list={SubscriptionList}
        edit={SubscriptionEdit}
        create={SubscriptionCreate}
        icon={Subscriptions}
      />,
      
      permissions === 'admin' && <Resource name="Transaction" list={TransactionList} icon={Payment} />,
      permissions === 'admin' && <Resource name="VodTransaction" list={VodTransactionList} icon={Payment} options={{ label: "Achats VODs" }}/>,
      <Resource name="User" list={UserList} edit={UserEdit} icon={People} />,
      permissions === 'admin' && <Resource
        name="News"
        list={NewsList}
        create={NewsCreate}
        edit={NewsEdit}
        icon={BookmarksIcon}
      />,
      permissions === 'admin' && <Resource
        name="Messages"
        list={MessageList}
        edit={MessageEdit}
        icon={Message}
      />,
      permissions === 'admin' && <Resource
        name="GlobalMessage"
        list={GlobalMessageList}
        create={GlobalMessageCreate}
        edit={GlobalMessageEdit}
        icon={Message}
      />,
      permissions === 'admin' && <Resource
        name="Survey"
        list={SurveyList}
        // create={GlobalMessageCreate}
        edit={SurveyEdit}
        icon={SurveyIcon}
      />,
      <Resource
        name="Casting"
        list={CastingApplicationList}
        // create={CastingApplicationCreate}
        show={CastingApplicationShow}
        // edit={CastingApplicationEdit}
        icon={CastingApplicationIcon}
      />
      ]}
      {/* <Resource name="users" list={UserList} edit={EditGuesser} icon={UserIcon}/>
    <Resource name="posts" list={PostList } edit={PostEdit} create={PostCreate} icon={PostIcon}/> */}
    </Admin>
  );
};
export default App;
